module.exports = __webpack_public_path__ + "html/press-twitter-gallery_d37316aa6e4c02d2c0f1364e79240426.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/press-twitter-gallery.html
// module id = SzCq
// module chunks = 151